import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { HttpHeaders } from '@angular/common/http';
import { Loginresponse } from '../interface'
import { _throw } from 'rxjs/observable/throw';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthenticationService {
	constructor(private http: HttpClient) {}
	login(username: string, password: string) {
		const httpOptions = {
			headers: new HttpHeaders({
				'username': username,
				'password': password,
				'usertype': "S",
				'apptype': "W"
			})
		};
		return this.http.post < Loginresponse > (environment.url + `userLogin`,"", httpOptions).pipe(map(Loginresponse => {
      if (Loginresponse.status_code = 200) {
        if (Loginresponse.Data) {
          if (Loginresponse) {
            var plan = {
              "utoken": btoa(Loginresponse.Data.utoken),
              "user_master_id": btoa(Loginresponse.Data.user_master_id),
              "org_id": btoa(Loginresponse.Data.org_id),
              "first_name": btoa(Loginresponse.Data.first_name),
              "middle_name": btoa(Loginresponse.Data.middle_name),
              "last_name": btoa(Loginresponse.Data.last_name),
              "profile_pic": btoa(Loginresponse.Data.profile_pic),
              "email_id": btoa(Loginresponse.Data.email_id),
              "system_user": btoa(Loginresponse.Data.system_user),
              "system_role_id": btoa(Loginresponse.Data.system_role_id),
              "gender": btoa(Loginresponse.Data.gender),
              "system_roles": btoa(Loginresponse.Data.system_roles),
              "profileimage_path": btoa(Loginresponse.Data.profileimage_path),
            }
            localStorage.setItem('currentUser', JSON.stringify(plan));
          }
        }
        return Loginresponse;
      } else {
        return Loginresponse
      }
    }));
	}

	forgotPasswordgetotp(mobilenumber:any) {
		const httpOptions = {
			headers: new HttpHeaders({
				'mobileno': mobilenumber,
				'action': 'generateOtp',
			})
		}
		return this.http.post < any > (environment.url + `forgotPassword`, '', httpOptions)
	}

	forgotPasswordsave(newpassword:any,confirmpassword:any,otp:any, mobile:any) {
		const httpOptions = {
			headers: new HttpHeaders({
				'newpassword': newpassword,
				'confirmpassword': confirmpassword,
				'otp': otp,
				'mobileno': mobile,
				'action': 'saveNewPassword',
			})
		}
		return this.http.post < any > (environment.url + `forgotPassword`, '', httpOptions)
	}

	logout() {
		// remove user from local storage to log user out
		localStorage.removeItem('currentUser');
	}
}


// WEBPACK FOOTER //
// ./src/app/_services/authentication.service.ts